import React from 'react';
import { FormFieldsData, ModalForm } from 'framework/form';
import { Modal } from 'framework/ui/ui-builder';
import ClientPortalInviteUserForm from './ClientPortalInviteUserForm';
import { clientPortalInviteUserFormValidation } from './clientPortalInviteUserFormValidation';
import type { ClientPortalInviteUserFormValues } from './types';
import useAccountManagementService from '../useAccountManagementService';

interface ClientPortalInviteUserModalProps {
  accountAlias: StringOrNumber;
  defaultAccessUntil?: string;
  isOpen: boolean;
  onClose: () => void;
  onInvited: () => void;
}

const ClientPortalInviteUserModal = ({
  accountAlias,
  defaultAccessUntil,
  isOpen,
  onClose,
  onInvited,
}: ClientPortalInviteUserModalProps) => {
  const { createPortalInvitation } = useAccountManagementService();

  const inviteUser = (values: FormFieldsData<ClientPortalInviteUserFormValues>) => {
    const { id, firstName, lastName, email, accessUntil } = values;

    return createPortalInvitation(accountAlias, {
      ...(id ? { id } : {}),
      firstName,
      lastName,
      email,
      accessUntil,
    });
  };

  return (
    <Modal isOpen={isOpen} onToggle={onClose} title="Invite user to the client portal">
      <ModalForm
        modalOpen={isOpen}
        closeModal={onClose}
        submitFormFunc={inviteUser}
        initialData={{ accessUntil: defaultAccessUntil, budgetEndDate: defaultAccessUntil }}
        afterSubmit={{ execute: onInvited }}
        submitButtonText="Invite"
        getValidationSchemaFunc={() => Promise.resolve(clientPortalInviteUserFormValidation)}
      >
        <ClientPortalInviteUserForm />
      </ModalForm>
    </Modal>
  );
};

export default ClientPortalInviteUserModal;
